<template>
  <div class="main-wrapper">
    <layout-header class="no-print"></layout-header>
    <layout-sidebar class="no-print"></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div ref="formContainer" class="row print">
          <div class="col-md-12">
            <div class="row statement-wrapper" style="margin-top: 16px;">
              <div v-if="statement" ref="statementContainer" class="col-lg-9 mb-5">
                <div class="card" style="margin-bottom: 0.8em" v-if="hasButtonPermissions || displayDisabledButtons">
                  <div class="card-body">
                    <div v-if="statement" class="mt-0">
                      <span>Period: </span>
                      <date-picker
                        v-model="selectedTime"
                        valueType="format"
                        type="date"
                        range
                        input-class="form-control"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <div v-if="!isLoading" id="printMe" ref="printMe" class="card">
                  <div class="card-header pb-4">
                    <div class="row mt-3 pt-3">
                      <div v-if="store" class="col-md-6 col-sm-12">
                        <div v-if="logoUrl" class="mb-4">
                          <img :src="logoUrl" alt="" class="preview img-fluid" style="max-width: 180px;"/>
                        </div>
                        <div>
                          <span style="font-weight: bold">{{ store && store.name.toUpperCase() }}</span>
                        </div>
                        <div>
                          <span class="pre-line">{{ store.address }}</span>
                        </div>
                        <div>
                          <span>{{ store.email }}</span>
                        </div>
                        <div>
                          <span>{{ store.phone }}</span>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 pull-left quote-header">
                        <div class="row">
                          <div class="col-md-12 col-sm-6">
                            <h2 v-if="isExporting" id="docName" class="text-right mr-3"
                                style="font-family: 'Gill Sans',serif; font-weight: bolder"> STATEMENT</h2>
                            <h2 v-if="!isExporting" class="text-left mr-5 w101">
                              <label class="input text-right w99" readonly="readonly"
                                     style="font-family: 'Gill Sans',serif; font-weight: bolder"
                                     type="text"> STATEMENT</label>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 mb-0">
                      <div class="col-md-6 col-sm-12 mt-3">
                        <table v-if="customer"
                               class="tblStatementHeaderDetails table table-hover table-center mb-0 datatable">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                            <td v-if="customer && customer.fullName" class="text-left">To:</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td v-if="customer" class="text-left">
                              <a :href="'/customers/' + customer.id" class="text-decoration-none text-dark">
                                {{ customer.fullName || customer.fullName }}
                              </a>
                            </td>
                          </tr>
                          <tr v-if="customer.email" class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">{{
                                customer.email
                              }}
                            </td>
                          </tr>
                          <tr v-if="customer.phone" class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">{{
                                customer.phone
                              }}
                            </td>
                          </tr>
                          <tr v-if="customer.address" class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ customer.address }}</span></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-6 col-sm-12 mt-3">
                        <table class="tblStatementHeaderDetails table table-hover table-center mb-0 datatable ">
                          <tbody>
                          <tr class="text-right borderless text-white"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); background-color: rgb(102, 102, 102)">
                            <td class="text-left" style="font-weight: bold"><span>Account Summary</span></td>
                            <td class="text-right"></td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Period:</td>
                            <td class="text-right">{{ toLocalDate(statement.startDate) }} to
                              {{ toLocalDate(statement.endDate) }}
                            </td>
                          </tr>
                          <tr v-if="statement.account && statement.account.currency" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Currency:</td>
                            <td class="text-right">{{ statement.account.currency }}</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Total Invoices:</td>
                            <td class="text-right">{{ (statement.totalDebits / 100 || 0.00).toFixed(2) }}</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Credit Notes:</td>
                            <td class="text-right">{{ (statement.totalCreditNotes / 100 || 0.00).toFixed(2) }}</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Total Payments:</td>
                            <td class="text-right">{{ (statement.totalCredits / 100 || 0.00).toFixed(2) }}</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Total Refunds:</td>
                            <td class="text-right">{{ (statement.totalRefunds / 100 || 0.00).toFixed(2) }}</td>
                          </tr>
                          </tbody>
                        </table>
                        <hr style="margin-bottom: 5px; margin-top: 5px">
                        <table class="tblStatementHeaderDetails table table-hover table-center mb-0 datatable ">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); background-color: #f5f5f5">
                            <td class="text-left" style="font-weight: bold">Balance:</td>
                            <td class="text-right" style="font-weight: bold">
                              {{ displayAmount(statement.account.currency, statement.closingBalance) }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <hr style="margin-bottom: 5px; margin-top: 5px">
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-2">
                    <div class="table">
                      <div>
                        <table id="tblItems" class="tblItems table table-hover table-center mb-0 datatable"
                               :class="windowWidth < 768 ? 'cards': ''">
                          <thead id="items-header" style="background-color: #666; color: white">
                          <tr class="text-center">
                            <th scope="col" class="text-left">Date</th>
                            <th scope="col" class="text-left">Description</th>
                            <th scope="col" v-if="statement.account" class="text-left" hidden>Amount
                              ({{ statement.account.currency }})
                            </th>
                            <th scope="col" v-if="statement.account" class="text-left">Debit</th>
                            <th scope="col" v-if="statement.account" class="text-left">Credit</th>
                            <th scope="col" v-if="statement.account" class="text-right">Balance ({{
                                statement.account.currency
                              }})
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="text-left" style="background-color: white">
                            <td col="Date: " class="text-left" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ utcDateToLocal(statement.startDate) }}
                              </span>
                            </td>
                            <td col="Description: " style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                                <span>
                                  Opening Balance
                                </span>
                            </td>
                            <td col="Debit: " style="padding-top: 0.35rem; padding-bottom: 0.35rem"></td>
                            <td col="Credit: " style="padding-top: 0.35rem; padding-bottom: 0.35rem"></td>
                            <td col="Balance (USD): " class="text text-right"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                                <span>
                                  {{ displayAmount(statement.account.currency, statement.openingBalance) }}
                                </span>
                            </td>
                          </tr>
                          <tr v-for="transaction in statement.transactions" :key="transaction.id"
                              class="text-left" style="background-color: white">
                            <td col="Date: " class="text-left" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ utcDateToLocal(transaction.date) }}
                              </span>
                            </td>
                            <td col="Description: " class="text-left"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>{{ transaction.description }}</span>
                            </td>
                            <td col="Amount: " class="text-left" hidden
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span v-if="transaction.type === 'DEBIT'" style="color: orangered">
                                {{
                                  transaction.type === 'DEBIT' && transaction.amount ? displayAmount(statement.account.currency, transaction.amount) : '-'
                                }}
                              </span>
                              <span v-if="transaction.type === 'CREDIT'" style="color: green">
                                {{
                                  transaction.type === 'CREDIT' && transaction.amount ? displayAmount(statement.account.currency, transaction.amount) : '-'
                                }}
                              </span>
                            </td>
                            <td col="Debit: " class="text-left" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span v-if="transaction.type === 'DEBIT'">
                                {{
                                  transaction.type === 'DEBIT' && transaction.amount ? displayAmount(statement.account.currency, transaction.amount) : '-'
                                }}
                              </span>
                            </td>
                            <td col="Credit: " class="text-left" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span v-if="transaction.type === 'CREDIT'">
                                {{
                                  transaction.type === 'CREDIT' && transaction.amount ? displayAmount(statement.account.currency, transaction.amount) : '-'
                                }}
                              </span>
                            </td>
                            <td col="Remaining Balance: " v-if="statement.account && statement.account.currency"
                                class="text-right"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span v-if="transaction.balanceAfter === 0">
                                {{ displayAmount(statement.account.currency, 0) }}
                              </span>
                              <span v-else>
                                {{
                                  transaction.balanceAfter ? displayAmount(statement.account.currency, transaction.balanceAfter) : '-'
                                }}
                              </span>
                            </td>
                          </tr>
                          <tr class="text-left" style="background-color: white">
                            <td col="End Date: " class="text-left"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                                <span>
                                  {{ toLocalDate(statement.endDate) }}
                                </span>
                            </td>
                            <td col="Description: " style="padding-top: 0.35rem; padding-bottom: 0.35rem;">
                                <span>
                                  Closing Balance
                                </span>
                            </td>
                            <td style="padding-top: 0.35rem; padding-bottom: 0.35rem">

                            </td>
                            <td style="padding-top: 0.35rem; padding-bottom: 0.35rem">

                            </td>
                            <td col="Balance: " class="text text-right"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem;">
                                <span>
                                  {{ displayAmount(statement.account.currency, statement.closingBalance) }}
                                </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <hr hidden style="margin-bottom: 0.3em; margin-top: 0.3em"/>

                        <div class="row mb-0" hidden>
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12">
                            <table class="tblPayments table table-hover table-center mb-0 datatable">
                              <tbody>
                              <tr
                                v-if="statement.account && statement.amountPaidCurrency !== statement.account.currency"
                                class="text-right borderless"
                                hidden
                                style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Paid:</td>
                                <td class="text-right">{{
                                    statement.amountPaidCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: statement.amountPaidCurrency
                                    }).format(statement.amountPaid / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold; background-color: #f5f5f5">
                                <td class="text-left">Closing Balance:</td>
                                <td v-if="statement.account" class="text-right">{{
                                    statement.account.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: statement.account.currency
                                    }).format(account.balance * (-1) / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="statement.notes" id="termsAndConditions" class="row mt-0">
                      <div class="col-12">
                        <label class="form-label me-1"></label>
                        <span class="show-footer-label-modal text-decoration-dotted form-label">
                          <label class="w101 bold" readonly="readonly"
                                 style="height: 35px; font-weight: bold; margin-bottom: 0px;"
                                 type="text">Notes:</label>
                        </span>
                        <span class="white-space pre-line">
                          {{ statement.notes }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!isExporting"
                         style="overflow-y: auto; min-height: calc(100vh - 500px) !important;"></div>
                  </div>
                  <div class="card-footer" hidden>
                  </div>
                </div>
                <template v-else>
                  <DocumentSkeleton :rows="10" :columns="6"/>
                </template>
              </div>
              <div class="col-lg-3 no-print">
                <div hidden class="card" v-if="hasButtonPermissions || displayDisabledButtons">
                  <div class="card-body">
                    <h6 class="card-title d-flex justify-content-between">
                      <span>
                        Select date range
                        <i v-popover:tooltip.top="'Choose a date range to filter statement transactions'"
                           class="fas fa-info-circle"
                           style="color: darkgrey"
                           data-toggle="tooltip"
                           data-placement="top"
                           title=""></i>
                      </span>
                    </h6>
                    <div v-if="statement" class="mt-0">
                      <date-picker
                        style="width: 100%"
                        v-model="selectedTime"
                        valueType="format"
                        type="date"
                        range
                        input-class="form-control"
                      ></date-picker>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <div v-if="statement" class="mt-0">
                      <button :disabled="isLoading"
                              class="btn btn-block bg-dark text-white" style="background-color: #004A59" type="button"
                              @click.prevent="downloadAsPdf"><i
                        class="fas fa-download"></i> Download As PDF
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js/src";
import {base64StringToBlob} from "blob-util";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import {enumToHumanReadable, toFilename, toLocalDate, utcDateToLocal} from "../../../../utils/utils";
import {displayAmount} from "../../../../utils/money";
import storeService from "../../../../service/store.service";
import fileService from "../../../../service/file.service";
import customerService from "../../../../service/customer.service";
import accountService from "../../../../service/account.service";
import customerStatementService from "../../../../service/customer.statement.service";
import receiptService from "../../../../service/receipt.service";
import invoiceService from "../../../../service/invoice.service";
import {getConfig} from "../../../../utils/config";
import axios from "axios";
import {API_URL} from "../../../../utils/config.util";
import authHeader from "../../../../service/auth-header";
import {errorCodes} from "../../../../interceptors/codes";
import DocumentSkeleton from "../../../shared/DocumentSkeleton";
import {handleError} from "../../../../utils/notification.utils";

export default {
  name: "ViewCustomerStatement",
  components: {
    DatePicker,
    DocumentSkeleton,
  },
  data() {
    return {
      emails: [],
      statement: {
        openingBalance: 0.00,
        totalDebits: 0.00,
        totalCredits: 0.00,
        closingBalance: 0.00,
        startDate: undefined,
        endDate: undefined,
        account: {
          currency: undefined
        },
        transactions: [
          {balanceAfter: 0.00}
        ]
      },
      selectedTime: null,
      selectedTemplateId: null,
      customerId: null,
      accountId: null,
      account: null,
      store: null,
      customer: {
        id: null,
        fullName: null
      },
      isLoading: true,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      printStatement: true,
      logoUrl: undefined,
      isExporting: false,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    basedOnWindowWidth() {
      if (this.windowWidth > 768) {
        return true;
      }
      return false;
    }
  },
  methods: {
    disabledDates(date) {
      const today = new Date();
      return date > today;
    },
    toLocalDate: toLocalDate,
    utcDateToLocal: utcDateToLocal,
    displayAmount(currency, amount) {
      return displayAmount(currency, amount);
    },
    formatAccountBalance(type, amount) {
      if (type === 'CHART_OF_ACCOUNT') {
        return Number(amount) / 100;
      } else {
        return Number(amount) / 100
      }
    },
    enumToHumanReadable: enumToHumanReadable,
    retrieveLogo(businessId) {
      this.isLoading = true;
      const merchantId = businessId || localStorage.getItem("mid");
      return new Promise((resolve, reject) => {
        fileService.fetchLogo(merchantId)
          .then(response => {
            if (!response) {
              return;
            }
            if (response && response.data.success === true) {
              const contentType = 'image/png';
              const blob = base64StringToBlob(response.data.data.bytes, contentType);
              this.logoUrl = URL.createObjectURL(blob);
              resolve([true, 'Successful', response.data])
              return
            }
            resolve([false, 'Successful', response.data.narrative])
          })
          .catch(e => {
            if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              return
            }
            reject([false, 'Error occurred', e])
            this.fireNotification('error', "Error occurred", "Failed to retrieve store logo")
          })
          .finally(() => {
            this.isLoading = false;
          })
      })
    },

    async downloadAsPdf() {
      this.isLoading = true;
      try {
        const context = JSON.parse(localStorage.getItem('selectedContext'));
        if (!context || !context.contextId) {
          throw new Error('Customer context is required');
        }
        const customerId = context.contextId;
        
        const startDate = this.selectedTime ? new Date(this.selectedTime[0]) : null
        const endDate = this.selectedTime ? new Date(this.selectedTime[1]) : null

        const params = new URLSearchParams();

        params.append("startDate", moment(startDate).startOf('day').toISOString());
        params.append("endDate", moment(endDate).endOf('day').toISOString());
        params.append("businessId", localStorage.getItem('mid'));
        
        const response = await axios.get(API_URL + `/v1/customers/${customerId}/statement/pdf?${params.toString()}&templateId=${this.selectedTemplateId}`, {
          responseType: "arraybuffer", // Important to handle binary data
          headers: authHeader(),
        });

        // Convert response data into a Blob
        const blob = new Blob([response.data], {type: "application/pdf"});

        // Generate Blob URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Statement_${toFilename(this.customer.fullName)}_${toLocalDate(startDate)}_to_${toLocalDate(endDate)}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Error downloading PDF:", e);
        const error = errorCodes[e.response.status];
        await Swal.fire({
          icon: error ? error.icon : "warning",
          title: 'Failed',
          text: e.response.data.narrative || e.response.data.description || "Error downloading PDF",
          footer: '<a href="">Why do I have this issue?</a>'
        })
      } finally {
        this.isLoading = false;
      }
    },

    async retrieveAccountStatement() {
      this.isLoading = true;
      const startDate = this.selectedTime ? moment(this.selectedTime[0]).startOf('day').toDate() : moment().startOf('year').toDate();
      const endDate = this.selectedTime ? moment(this.selectedTime[1]).endOf('day').toDate() : moment().endOf('day').toDate();
      const params = {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        templateId: this.selectedTemplateId
      }
      return customerStatementService.find(localStorage.getItem("mid"), params)
        .then(response => {
          if (response.data.code !== 'SUCCESS') {
            Swal.fire({
              icon: 'warning',
              title: '',
              text: response.data.description || 'Failed to retrieve statement',
              footer: '<a href="">Why do I have this issue?</a>'
            })
            return;
          }

          const statement = response.data.data;
          
          // Map API response to component's expected structure
          this.statement = {
            openingBalance: statement.openingBalance || 0,
            totalDebits: statement.totalDebits || 0,
            totalCredits: statement.totalCredits || 0,
            closingBalance: statement.closingBalance || 0,
            startDate: statement.startDate,
            endDate: statement.endDate,
            transactions: (statement.statementLines || []).map(line => ({
              ...line,
              reference: line.referenceId, // Map referenceId to reference for template compatibility
              amount: line.amount, // Convert to cents as template divides by 100
              balanceAfter: line.balanceAfter // Convert to cents as template divides by 100
            })),
            account: {
              id: statement.accountId,
              currency: statement.currency || 'USD' // Use currency string from API or default
            }
          };
          
          // Store business and customer information from API
          this.store = statement.business;
          this.customer = {
            id: statement.customer ? statement.customer.customerId : null,
            fullName: statement.customer ? statement.customer.name : null,
            email: statement.customer ? statement.customer.email : null,
            phone: statement.customer ? statement.customer.phone : null
          };
          
          this.account = this.statement.account;
          this.invoicesTotal = statement.totalDebits || 0;
          this.paymentsTotal = statement.totalCredits || 0;
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            this.success = true
            this.message = e.response.data.narrative
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          this.isLoading = false
        });
    },
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    },
    'selectedTime': {
      handler(beforeVal, afterVal) {
        if (this.selectedTime && this.$route.path !== '/login') {
          this.retrieveAccountStatement()
        }
      },
      deep: true,
      immediate: true
    },
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }
    
    // Get customer ID from selectedContext
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    this.customerId = context ? context.contextId : null;
    
    if (!this.customerId) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Customer context is missing. Please log in again.',
      });
      return;
    }

    // Fetch statement first, which includes business and customer info
    this.selectedTemplateId = 'customer-statement-1';
    await this.retrieveAccountStatement();
    
    // Fetch logo after we have the business info
    if (this.store && this.store.id) {
      await this.retrieveLogo(this.store.id);
    }

    const startDateString = this.$route.query.startDate;
    const endDateString = this.$route.query.endDate;

    let startDate;
    let endDate;

    if (startDateString && endDateString) {
      startDate = moment(startDateString).toISOString(true)
      endDate = moment(endDateString).toISOString(true)
    } else {
      const defaultStartDate = moment().year(2023).startOf('year').toISOString(true);
      const startOfYear = moment().startOf('year').toISOString(true);
      startDate = this.selectedTime ? moment(this.selectedTime[0]).toISOString(true) : defaultStartDate
      endDate = this.selectedTime ? moment(this.selectedTime[1]).toISOString(true) : moment().toISOString(true)
    }
    this.selectedTime = [startDate, endDate]
  },
}
</script>

<style scoped>
.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}

.white-space {
  width: 200px;
}

.pre-line {
  white-space: pre-line;
}

.w99 {
  width: 100%;
  border: none white;
}

.w101 {
  width: 100%;
  height: 35px;
  border: none white;
}

.printBoarder {
  border: 1px solid lightgray;
  border-radius: 5px;
}


.tblItems thead tr th {
  padding: 0.50rem !important;
}

.tblItems tbody tr td {
  padding: 0.30rem !important;
}


.tblTotals tbody tr td {
  padding: 0.30rem !important;
}

.tblTotals tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblTotals tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

tr.noBorder td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0.05);
  background-color: #f5f5f5;
}


.tblPayments tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblPayments tbody tr td {
  padding: 0.50rem !important;
}

.tblPayments tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}


.tblStatementHeaderDetails tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblStatementHeaderDetails tbody tr td {
  padding: 0.20rem !important;
}

.tblStatementHeaderDetails tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }

  #items-header {
    background-color: black;
    color: white;
  }

  .no-print {
    display: none !important;
  }

  .result {
    height: 100%;
    overflow: visible;
  }

  .printBoarder {
    border: none !important;
    border-radius: 0 !important;
  }
}

@media only screen and (max-width: 900px) {

  .quote-header {
    display: none;
  }

  #printMe {
    width: 100%;
    height: 100%;
  }

  .statement-wrapper {
    margin-top: 16px;
    margin-left: 0;
    margin-right: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customers/accounts/statements/ViewCustomerStatement.vue